import moment from "moment";

import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";

import PlayerAvatar from "@/components/PlayerAvatar";

import "./index.scss";

// ── Component ─────────────────────────────────────────────────────────────────

export default function MedicalRecordCard({element}) {
	const player = element?.playerData || {};
	const firstName = player.firstName || "";
	const lastName = player.lastName || "";
	const fullName = [firstName, lastName].filter(Boolean).join(" ") || "—";
	const birthYear = player.dateOfBirth ? moment(player.dateOfBirth).format("YYYY") : null;
	const category = player.category || null;
	const lastUpdate = element?.updatedAt || element?.createdAt || null;

	const chips = [category, birthYear].filter(Boolean);

	return (
		<div className="mrc">
			<PlayerAvatar
				firstName={firstName}
				lastName={lastName}
				imageUrl={player.imageUrl}
			/>

			<div className="mrc__body">
				<span className="mrc__name">{fullName}</span>
				{chips.length > 0 && (
					<div className="mrc__chips">
						{chips.map((chip) => (
							<span key={chip} className="mrc__chip">{chip}</span>
						))}
					</div>
				)}
			</div>

			<div className="mrc__side">
				<LocalHospitalOutlinedIcon className="mrc__icon" />
				{lastUpdate && (
					<span className="mrc__date">
						{moment(lastUpdate).format("DD/MM/YY")}
					</span>
				)}
			</div>
		</div>
	);
}
